import { useEffect } from "react";
import { recordArticleView } from "@/lib/analytics.functions";

/**
 * Fire-and-forget first-party pageview counter.
 *
 * De-dupes per browser session so a refresh or a client-side return to the
 * same article doesn't inflate the count, and never blocks or breaks render.
 */
export function useRecordArticleView(slug: string | undefined) {
  useEffect(() => {
    if (!slug) return;
    if (typeof window === "undefined") return;

    const key = `mo:viewed:${slug}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    } catch {
      // Private mode / storage disabled — still count the view once per mount.
    }

    const timer = window.setTimeout(() => {
      void recordArticleView({ data: { slug } }).catch(() => {});
    }, 1200);

    return () => window.clearTimeout(timer);
  }, [slug]);
}
